import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { usePlayer } from '../contexts/PlayerContext';

const VisualizerContainer = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
`;

const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.05);
`;

const Visualizer: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { audioRef, isPlaying } = usePlayer();
  const animationRef = useRef<number | undefined>(undefined);
  const analyserRef = useRef<AnalyserNode | undefined>(undefined);
  const dataArrayRef = useRef<Uint8Array | undefined>(undefined);

  useEffect(() => {
    // Visualizador simplificado - implementar depois
  }, [audioRef]);

  useEffect(() => {
    if (isPlaying) {
      startVisualization();
    } else {
      stopVisualization();
    }
  }, [isPlaying]);

  const startVisualization = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Animação simples de barras
    const draw = () => {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < 20; i++) {
        const barHeight = Math.random() * canvas.height * 0.8;
        const x = (i * canvas.width) / 20;
        const barWidth = canvas.width / 25;

        ctx.fillStyle = `hsl(${30 + i * 10}, 70%, 60%)`;
        ctx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);
      }

      animationRef.current = requestAnimationFrame(draw);
    };

    draw();
  };

  const stopVisualization = () => {
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }
  };

  return (
    <VisualizerContainer>
      <Canvas ref={canvasRef} width={400} height={60} />
    </VisualizerContainer>
  );
};

export default Visualizer;